import { Component, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MailMeSearchDto } from 'src/app/shared/interfaces';
import { Cols } from 'src/app/shared/models/cols';
import { MailsMeSearchParams } from 'src/app/shared/models/mails/mails-me-search';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-courrier-tree-tbl',
  templateUrl: './home-courrier-tree-tbl.component.html',
  styleUrls: ['./home-courrier-tree-tbl.component.scss'],
})
export class HomeCourrierTreeTblComponent {
  @Input() set searchParams(value: MailsMeSearchParams) {
    if (value && value !== undefined) {
      value.IsAdvancedSearch = true;
      value.CalcTotal = false;
      this.searchMails(value);
      this.searchParamsValue = value;
    } else {
      this.mails = [];
      this.searchParamsValue = null;
    }
  }
  public searchParamsValue: MailsMeSearchParams = null;
  public mails: MailMeSearchDto[] = [];
  public columns: Cols[] = [
    {
      field: 'typeEntrantSortant',
      header: 'Type',
      sortable: true,
      format: (value: string): string => {
        if (value === 'S') {
          return 'Sortant';
        } else if (value === 'E') {
          return 'Entrant';
        } else {
          return 'Interne';
        }
      },
    },
    {
      field: 'objet',
      header: 'Objet',
      sortable: true,
      format: (value: string): string => {
        if (value) {
          return value.substring(0, 200) + '...';
        } else {
          return '';
        }
      },
    },
    {
      field: 'id',
      header: 'ID',
      sortable: true,
      format: (value: number): number => {
        return value;
      },
    },
    {
      field: 'serviceProprietaire',
      header: 'Service',
      sortable: true,
      format: (value: { description: string }): string => {
        if (value?.description) {
          return value.description;
        } else return '';
      },
    },
    {
      field: 'dateEntree',
      header: "Date d'entrée",
      sortable: true,
      format: (value: string): string => {
        if (value) {
          return moment(value).format('DD/MM/YYYY');
        } else return '';
      },
      sort: (a: string, b: string, order: number) => {
        const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
    },
    {
      field: 'preview',
      header: 'Aperçu',
      sortable: false,
      format: () => {
        return `<i class="bi bi-eye-fill"></i>`;
      },
      click: (column) => {
        this.openMailModal(column);
      },
    },
  ];
  public baseUrl: string;

  public sizeChoice = 200;
  public sizeOfPages = [
    { label: 'Maximum 200 courriers affichés', value: 200 },
    { label: 'Maximum 500 courriers affichés', value: 500 },
    { label: 'Maximum 1000 courriers affichés', value: 1000 },
    { label: 'Maximum 5000 courriers affichés', value: 5000 },
  ];

  constructor(
    private mailsService: MailsService,
    private spinner: NgxSpinnerService
  ) {
    const config = environment;
    this.baseUrl = config.baseUrl;
  }

  searchMails(data: MailsMeSearchParams): void {
    this.spinner.show();
    this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
      next: (response) => {
        this.mails = response.items;
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error : ', error);
        this.spinner.hide();
      },
    });
  }

  pageSizeChange(): void {
    if (this.searchParamsValue) {
      this.spinner.show();
      this.mailsService.getAllMails(this.searchParamsValue, this.sizeChoice).subscribe({
        next: (response) => {
          this.mails = response.items;
          this.spinner.hide();
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
        },
      });
    }
  }

  openMailModal(data): void {
    const url = '/private/ic/tabs/';
    window.open(this.baseUrl + url + data.id);
  }
}
